// extracted by mini-css-extract-plugin
module.exports = {"banner":"BannerB_banner___1TBN"};